import React from 'react'
import { toast } from 'react-toastify'
import { useForm } from 'react-hook-form'

import OrdersService from 'services/OrdersService'

const errorTranslations = {
  'The number must be at least 9 characters.':
    'ნომერი უნდა შედგებოდეს მინიმუმ 9 სიმბოლოსგან.',
}

const CallRequestForm = () => {
  const { register, handleSubmit, reset, errors, setError } = useForm({
    defaultValues: {
      topic: 'buy_wanted',
    },
  })

  const onCallRequestSubmit = data => {
    const formData = new FormData()
    formData.append('topic', data.topic)
    formData.append('number', data.number)

    OrdersService.calNeeded(formData)
      .then(() => {
        toast.success(
          'განაცხადი წარმატებით გამოიგზავნა, ოპერატორი მალე დაგიკავშირდებათ'
        )
        reset()
      })
      .catch(error => {
        const serverErrors = error.response?.data?.errors
        if (serverErrors?.number) {
          const englishMessage = serverErrors.number[0]
          const georgianMessage =
            errorTranslations[englishMessage] || englishMessage
          setError('number', {
            type: 'manual',
            message: georgianMessage,
          })
        } else {
          toast.error('დაფიქსირდა შეცდომა, სცადეთ თავიდან.')
        }
      })
  }

  return (
    <div className="invisible opacity-0 group-hover:visible group-hover:opacity-100 absolute top-full left-1/2 -translate-x-1/2 mt-2 bg-white shadow-md rounded-lg p-5 border border-slate-100 z-50 min-w-64 transition-all duration-300">
      <form onSubmit={handleSubmit(onCallRequestSubmit)}>
        <div className="flex flex-col text-[13px] text-[#3c4854] mb-4">
          <div className="flex items-center">
            <input
              type="radio"
              name="topic"
              value="buy_wanted"
              id="buy_wanted_radio"
              ref={register}
              className="w-4 h-4 accent-[#ff4b2b] mr-2 cursor-pointer"
            />
            <label htmlFor="buy_wanted_radio" className="cursor-pointer">
              ნივთის შეძენა
            </label>
          </div>
          <div className="flex items-center mt-3">
            <input
              type="radio"
              name="topic"
              value="need_help"
              id="need_help_radio"
              ref={register}
              className="w-4 h-4 accent-[#ff4b2b] mr-2 cursor-pointer"
            />
            <label htmlFor="need_help_radio" className="cursor-pointer">
              დახმარება მჭირდება
            </label>
          </div>
        </div>

        <h3 className="text-[15px] font-semibold mb-3 text-[#3c4854]">
          დატოვეთ ნომერი და დაგირეკავთ
        </h3>

        <input
          type="text"
          name="number"
          autoComplete="off"
          placeholder="+995 (---) --- ---"
          ref={register({ required: 'გთხოვთ, შეიყვანოთ ნომერი' })}
          className={`w-full mb-3 p-2 border rounded-md mb-1 focus:border-blue-400 focus:ring-2 focus:ring-blue-100 focus:outline-none transition-all duration-200 text-[#515c67] bg-white focus:bg-blue-50/30 ${
            errors.number ? 'border-red-500' : 'border-[#d9d9d9]'
          }`}
        />
        {errors?.number?.message && (
          <p className="text-red-500 text-[11px] mb-3 -mt-2">
            {errors.number.message}
          </p>
        )}

        <button
          type="submit"
          className="w-full bg-[linear-gradient(to_right_top,#ff4b2b,#ff453e,#ff424e,#ff405d,#ff416c)] text-white hover:shadow-[0_6px_20px_rgba(255,65,108,0.4)] font-semibold py-2.5 px-4 rounded-md transition-all duration-300 text-[15px]"
        >
          დამირეკე
        </button>
      </form>
    </div>
  )
}

export default CallRequestForm
